// extracted by mini-css-extract-plugin
module.exports = {"apploader":"loader_apploader__1KHL5","container":"loader_container__oUJCN","inner":"loader_inner__2hNZK","spin-animate":"loader_spin-animate__2r9hS"};